var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { CLEAR_INFO_IN_BLACKLIST, EXPAND_MSISDN, GET_BLACKLIST, GET_BLACKLIST_SUCCESS, GET_INFO_IN_BLACKLIST_SUCCESS } from './blacklist.actions';
import { createSelector } from 'reselect';
import { DefaultParams } from './blacklist.config';
export var initialState = {
    params: new DefaultParams(),
    list: {
        data: [],
        total: 0
    }
};
var changeFieldInElement = function (state, msisdn, data) {
    return __assign({}, state, { list: __assign({}, state.list, { data: state.list.data.map(function (element) { return (element.msisdn === msisdn ? __assign({}, element, data) : element); }) }) });
};
var ɵ0 = changeFieldInElement;
export function blacklistReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_BLACKLIST_SUCCESS:
            return __assign({}, state, { list: action.payload });
        case EXPAND_MSISDN:
            return changeFieldInElement(state, action.payload.element.msisdn, {
                expanded: action.payload.expanded
            });
        case GET_INFO_IN_BLACKLIST_SUCCESS:
            return changeFieldInElement(state, action.payload[0].msisdn, { additional: action.payload });
        case CLEAR_INFO_IN_BLACKLIST:
            return changeFieldInElement(state, action.payload.element.msisdn, { additional: null });
        case GET_BLACKLIST:
            return __assign({}, state, { params: action.payload });
        default: {
            return state;
        }
    }
}
export var getList = function (state) { return state.list.data; };
export var getListTotal = function (state) { return state.list.total; };
export var getParams = function (state) { return state.params; };
export var getMainBlacklistSelector = function (state) { return state.blacklist; };
export var getBlacklistSelector = createSelector(getMainBlacklistSelector, getList);
export var getBlacklistTotalSelector = createSelector(getMainBlacklistSelector, getListTotal);
export var getBlacklistParamsSelector = createSelector(getMainBlacklistSelector, getParams);
export { ɵ0 };
